<template>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="6">
              <table>
                 <tr v-if="isOperator">
                  <td>{{ $t('client') }}</td>
                  <td> : </td>
                  <td> <h3>{{ deliveryDoc.client_name }}</h3> </td>
                </tr>

                <tr>
                  <td>{{ $t('supplier') }}</td>
                  <td> : </td>
                  <td> <h3>{{ deliveryDoc.supplier_name }}</h3> </td>
                </tr>

                <tr>
                  <td>{{ $t('phone') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.supplier_mobile | formatPhoneNumber }}</td>
                </tr>

                <tr>
                  <td>{{ $t('date') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.date }}</td>
                </tr>

                <tr>
                  <td>{{ $t('totalAmount') }}</td>
                  <td> : </td>
                  <td><h3>{{ parseFloat(deliveryDoc.total_amount) | formatNumber }}{{ getCurrencySymbol(deliveryDoc.currency_code) }}</h3></td>
                </tr>

                <tr>
                  <td>{{ $t('note') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.note }}</td>
                </tr>

              </table>
          </v-col>

          <v-col cols="12" lg="6">
              <table>
                <tr>
                  <td>{{ $t('po_reference') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.po_reference }}</td>
                </tr>

                <tr>
                  <td>{{ $t('dn_reference') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.reference }}</td>
                </tr>
              
                <tr>
                  <td>{{ $t('deliveryName') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.delivery_name }}</td>
                </tr>

                <tr>
                  <td>{{ $t('driverPhone') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.driver_phone | formatPhoneNumber }}</td>
                </tr>

                <tr>
                  <td>{{ $t('truckPlateNumber') }}</td>
                  <td> : </td>
                  <td>{{ deliveryDoc.truck_plate_number }}</td>
                </tr>

              </table>
          </v-col>

        </v-row>
      

        <v-data-table
          :headers="deliveryLineHeader"
          :items="deliveryDoc.transaction_delivery_line"
          hide-default-footer
          mobile-breakpoint="0"
        >
          <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.price="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.product_description="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:item.delivery_qty="{ item }">{{ parseFloat(item.delivery_qty) | formatNumber }}</template>
          <template v-slot:item.product_description="{ item }">{{item.product_description && item.product_description.substr(0, 9) || ""}}{{ item.product_description && item.product_description.length > 9 ? "..." : "" }}</template>
          <template v-slot:item.price="{ item }">{{ item.price | formatNumber }}{{ item.currency_symbol }}</template>
          <template v-slot:item.total_amount="{ item }">{{ item.sub_total | formatNumber }}{{ item.currency_symbol }}</template>
        </v-data-table>

      </v-card-text>
      <v-card-actions>
        <v-btn
          elevation="2"
          rounded
          small
          depressed
          @click="handleClose(false)"
        >
          {{ $t('close') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
</template>
<script>
import MainMixin from "../../../mixins/mainMixin";

export default {
  name: "poDetail",
  props: ["deliveryDoc"],
  mixins: [MainMixin],

  data() {
    return {
      deliveryLineHeader: [
        {
          text: "productName",
          align: "start",
          sortable: false,
          value: "name"
        },
        {text: "qty", value: "qty", sortable: false},
        {text: "price", value: "price", sortable: false},
        {text: "amount", value: "total_amount", sortable: false},
      ],
    };
  },
  created() {
  },
  methods: {
    handleClose(val) {
      this.$emit('handleCloseDeliveryDetail', val);
    },
  }
};
</script>
